<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-totem-modal-list">
            <h2>Deseja iniciar o Batch?</h2>
         </div>
         
         <div class="body-modal-list">
            Você realmente deseja iniciar este Batch?
         </div>
         <div class="footer-modal-list">
            <button mat-button class="btn-primary block" (click)="clickStart()">
                <span *ngIf="isLoading == false">Sim, iniciar</span>
                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
            </button>
            <button mat-button class="btn-secundary block"(click)="clickCancel()">Cancelar</button>
        </div>
    </div>
</div>
